'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import MaterialInputAdornment from '@mui/material/InputAdornment';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import { excludeComponentProps } from '../utils/excludeComponentProps';
const StyledInputAdornment = styled(MaterialInputAdornment, {
    ...excludeComponentProps('noPadding')
})(({ position, noPadding }) => ({
    height: '100%',
    ...position === 'start' && {
        paddingLeft: noPadding ? 0 : '0.5rem'
    },
    ...position === 'end' && {
        paddingRight: noPadding ? 0 : '0.5rem'
    },
    '& .InputAdornment-adornment': {
        padding: '0 0.25rem',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        '&.InputAdornment-firstAdornment': {
            paddingLeft: 0
        },
        '&.InputAdornment-lastAdornment': {
            paddingRight: 0
        }
    }
}));
export const InputAdornment = React.forwardRef(({ children, position, ...props }, ref) => {
    const childrenCount = React.Children.count(children);
    return (_jsx(StyledInputAdornment, { ...props, position: position, ref: ref, variant: undefined, children: React.Children.map(children, (child, index) => {
            return React.cloneElement(_jsx("div", { className: clsx({
                    'InputAdornment-firstAdornment': position === 'start' && index === 0,
                    'InputAdornment-adornment': true,
                    'InputAdornment-lastAdornment': position === 'end' && index === childrenCount - 1
                }), children: child }));
        }) }));
});
InputAdornment.displayName = 'InputAdornment';
